import React, { useState } from "react";
import { Tabs } from "antd";
import SendNotificationPanel from "./components/SendNotificationPanel";
import NotificationPreviewPanel from "./components/NotificationPreviewPanel";
import NotificationDefinitionsTable from "./components/NotificationDefinitionsTable";

/**
 * Push Notifications — notifications-management module of api-gateway-internal.
 *
 * Read-only over the definitions: the CMS lists and inspects them, the
 * create/update/delete endpoints are deliberately not wired up here.
 *
 * Backend permissions behind this screen:
 *   get:all:notification:managements, get:notification:types,
 *   get:notification:keys:values, send:notification:management,
 *   get:users:with:fcm:token.
 */
const TABS_SCOPE = "push-notifications-tabs";

const PushNotifications = () => {
  const [activeTab, setActiveTab] = useState("send");

  return (
    <div className="overflow-y-auto px-20 sm:px-30 pt-40 pb-30 bg-light-grey-1 h-full w-full min-w-0">
      <h2 className="text-dark-grey font-bold text-2xl mb-8">
        Push Notifications
      </h2>
      <p className="text-dark-grey mb-30 text-sm" style={{ opacity: 0.6 }}>
        Send a push to known users, QA the localized copy behind every key, and
        review the notification definitions the sending job reads.
      </p>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className={TABS_SCOPE}
        items={[
          {
            key: "send",
            label: "Send Push",
            children: <SendNotificationPanel />,
          },
          {
            key: "preview",
            label: "Localized Preview",
            children: <NotificationPreviewPanel />,
          },
          {
            key: "definitions",
            label: "Definitions",
            children: <NotificationDefinitionsTable />,
          },
        ]}
      />

      <style>{`
        .${TABS_SCOPE} .ant-tabs-nav {
          margin-bottom: 24px;
        }
        .${TABS_SCOPE} .ant-tabs-nav::before {
          border-bottom-color: #E6E8EF;
        }
        .${TABS_SCOPE} .ant-tabs-tab {
          padding: 12px 2px;
          font-size: 18px;
          font-weight: 600;
        }
        .${TABS_SCOPE} .ant-tabs-tab + .ant-tabs-tab {
          margin-left: 32px;
        }
        .${TABS_SCOPE} .ant-tabs-tab .ant-tabs-tab-btn {
          color: #6b7280;
          letter-spacing: -0.01em;
        }
        .${TABS_SCOPE} .ant-tabs-tab:hover .ant-tabs-tab-btn {
          color: #2d3ac7;
        }
        .${TABS_SCOPE} .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #2d3ac7;
          font-weight: 700;
        }
        .${TABS_SCOPE} .ant-tabs-ink-bar {
          background: #2d3ac7;
          height: 3px;
          border-radius: 3px 3px 0 0;
        }
      `}</style>
    </div>
  );
};

export default PushNotifications;
